import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { FaDigitalTachograph, FaShippingFast, FaTrailer } from "react-icons/fa";
import { TbTicket } from "react-icons/tb";

import OneTimeShipperProfileModal from "./Components/ProfileModal/OneTimeShipperProfileModal";
import AuthComponent from "../../Pages/Authentication/Components/AuthComponent/AuthComponent";
import Navbar from "./Navbar";

function OneTimeShipperNavbar() {
  const user = useSelector((state) => state.user);
  const [navItems, setNavItems] = useState([]);

  useEffect(() => {
    setNavItems([
      {
        label: "Ship",
        i18nKey: "nav:ship",
        url: "/",
        name: "shipper.access.shipment.create",
        unReadData: null,
        icon: FaShippingFast,
      },
      {
        label: "Shipments",
        i18nKey: "nav:shipments",
        url: "/shipments",
        name: "shipper.access.shipment.view",
        unReadData: user?.unReadShipments,
        icon: FaTrailer,
      },
      {
        label: "Finances",
        i18nKey: "nav:finances",
        url: "/payments",
        name: "shipper.access.payment.view",
        unReadData: null,
        icon: FaDigitalTachograph,
      },
      {
        label: "Tickets",
        i18nKey: "nav:tickets",
        url: "/Tickets",
        name: "shipper.access.ticket.view",
        unReadData: null,
        icon: TbTicket,
      },
    ]);
  }, [user]);

  const profileModal = ({ onClose }) => (
    <OneTimeShipperProfileModal
      onClose={onClose}
      style={{ top: "50px", right: "0" }}
    />
  );

  return (
    <>
      <AuthComponent />
      <Navbar
        navItems={navItems}
        profileImage={user?.profile_image}
        profileModal={profileModal}
      />
    </>
  );
}

export default OneTimeShipperNavbar;
